import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RegistroProduto } from '../models/registro-produto';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService extends AbstractService<RegistroProduto> {

  titulo: string = 'Módulo / Solução ';
  endpoint(): string {
    return "registro/produto";
  }
  rotina(): string {
    return "PRODUTOS";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Código Hábil", field: "idInterno" },
      { header: "Nome", field: "nomeProduto" },
    ];
  }

  corrigeAtributos(t) {
    t.acessos = [];
    for (let acesso of t['acessosComDescricao']) {
      t.acessos.push(acesso.value);
    }
    t['acessosComDescricao'] = [];
    return super.corrigeAtributos(t);
  }

  private getHeaders(): HttpHeaders {
    return     new HttpHeaders({
      Accept: "application/json; charset=utf-8",
      "X-Auth-Token": AbstractService.token(),
    });

  }

  getModulosAdicionais(): Observable<any[]> {
    const url = this.baseUrl() + "/modulos-adicionais";

    return this.http.get<any[]>(url, { headers: this.getHeaders() });
  }

  getAcessos(): Observable<any> {
    const url = this.baseUrl() + "/acessos";

    return this.http.get<any[]>( url, {headers: this.getHeaders() });
  }

  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/produtos/cadastro']);
  }
  abrir(obj: RegistroProduto) {
    AbstractService.readonly = true;
    this.router.navigate(['adm/produtos/cadastro'], { queryParams: { id: obj.id } });
  }
  edit(obj: RegistroProduto) {
    AbstractService.readonly = false;
    this.router.navigate(['adm/produtos/cadastro'], { queryParams: { id: obj.id } });
  }
  routeLista() {
    return '/adm/produtos';
  }

  constructor(
    public http: HttpClient,
    private router: Router,
    public loginService: LoginService
  ) {
    super(http, loginService);
  }
}
